import { render, staticRenderFns } from "./AwesomeBar.vue?vue&type=template&id=1dd06deb&"
import script from "./AwesomeBar.vue?vue&type=script&lang=js&"
export * from "./AwesomeBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports